import React, { Component, Fragment } from 'react';
import { Button } from 'reactstrap';

const DEBUG_FREE_PRODUCT = true; // set false when done debugging

class FreeProduct extends Component {
    constructor(props) {
        super(props);

        this.state = {
            freeProduct: null,
            freeProductIndex: null
        };
        this.lastCloseCall = 0;

        this.handleViewProduct = this.handleViewProduct.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCloseTouchStart = this.handleCloseTouchStart.bind(this);
    }

    // Set flag as soon as user touches X so overlay's later click can be ignored (it can fire before touchend on some devices)
    handleCloseTouchStart(e) {
        if (e) e.stopPropagation();
        if (typeof window !== 'undefined') window.__freeProductClosedByButtonAt = Date.now();
        if (DEBUG_FREE_PRODUCT) console.log('[FreeProduct] touchstart on X, set __freeProductClosedByButtonAt');
    }

    handleClose(e) {
        const now = Date.now();
        if (DEBUG_FREE_PRODUCT) {
            console.log('[FreeProduct] handleClose', e?.type, 'at', now, 'lastCloseCall', this.lastCloseCall, 'delta', now - this.lastCloseCall);
        }
        // Avoid double-toggle: touchend and click both fire on mobile; only act once per tap
        if (now - this.lastCloseCall < 400) {
            if (DEBUG_FREE_PRODUCT) console.log('[FreeProduct] handleClose SKIP (debounce)');
            if (e) { e.stopPropagation(); e.preventDefault(); }
            return;
        }
        this.lastCloseCall = now;

        if (e) {
            e.stopPropagation();
            if (e.type === 'touchend') {
                e.preventDefault();
            }
        }
        if (typeof window !== 'undefined') window.__freeProductClosedByButtonAt = now;
        if (DEBUG_FREE_PRODUCT) console.log('[FreeProduct] handleClose calling onToggle("fromButton") -> modal will CLOSE');
        this.props.onToggle('fromButton');
    }

    componentDidMount() {
        this.applyTheme();

        this.props.shoppingCart.orderProducts.map((product, index) => {
            if (product.promotionFreeProduct) {
                this.setState({
                    ...this.state,
                    freeProduct: product,
                    freeProductIndex: index
                })
            }
        })
    }

    handleViewProduct(e) {
        // Prevent event from bubbling to modal overlay (fixes first-tap issue on mobile)
        if (e) {
            e.stopPropagation();
            // Prevent click event from firing after touchend (avoid double trigger)
            if (e.type === 'touchend') {
                e.preventDefault();
            }
        }
        this.props.onEdit(this.state.freeProduct, this.state.freeProductIndex);
        this.props.onToggle();
    }

    renderModalHeader() {
        return (
            <div style={styles.headerStyle}>
                <h3>{this.props.shoppingCart.appliedPromotions[0].name}</h3>
                {!this.props.isPwa ? <div
                    id="customCloseBtn"
                    className='available-discounts'
                    role="button"
                    tabIndex={0}
                    style={{ marginTop: 5, position: 'absolute', top: 0, right: 5, touchAction: 'manipulation' }}
                    onTouchStart={this.handleCloseTouchStart}
                    onClick={this.handleClose}
                    onTouchEnd={this.handleClose}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.handleClose(e); } }}
                /> : null}
            </div>
        )
    }

    renderModalBody() {
        const productName = this.state.freeProduct ? this.state.freeProduct.name : '';
        const isCheckoutScreen = window.location.href.includes('/checkout');

        return (
            <Fragment>
                <p style={isCheckoutScreen ? {...styles.bodyContainer, marginBottom: '0px'} : styles.bodyContainer}>
                    {`Congratulations! You received a free ${productName}.`}
                </p>
            </Fragment>
        )
    }

    renderModalFooter() {
        const { buttonsMainContainer, buttonsContainer, editButton, buttonsStyle } = styles;
        
        return (
            <div style={buttonsMainContainer}>
                <div style={buttonsContainer}>
                    <Button
                        style={{ ...buttonsStyle, ...editButton, touchAction: 'manipulation' }}
                        onClick={this.handleViewProduct}
                        onTouchEnd={this.handleViewProduct}>
                        {'View Product'}
                    </Button>
                </div>
            </div>
        )
    }

    applyTheme() {
        let customizedStyles = JSON.parse(JSON.stringify(styles));
        const {
            primaryColor,
            primaryFontColor,
            mainTextColor,
            menuItemsBackground,
            buttonsFont,
            fontFamilyType,
            fontBold,
            fontItalic,
            uppercase
        } = this.props.customerThemes.selectedTheme;

        customizedStyles.mainContainer.backgroundColor = menuItemsBackground;
        customizedStyles.headerStyle.color = primaryFontColor;
        customizedStyles.buttonsStyle.color = buttonsFont;
        customizedStyles.bodyContainer.color = mainTextColor;
        customizedStyles.editButton.backgroundColor = primaryColor;
        customizedStyles.buttonsStyle.fontFamily = fontFamilyType;
        customizedStyles.buttonsStyle.fontWeight = fontBold === 'bold' ? this.props.customerThemes.selectedTheme.fontBold : 300;
        customizedStyles.buttonsStyle.fontStyle = fontItalic;
        customizedStyles.buttonsStyle.textTransform = uppercase;

        styles = customizedStyles;
        return styles;
    }

    render() {
        const isCheckoutScreen = window.location.href.includes('/checkout');
        return (
            <div style={styles.mainContainer}>
                {this.renderModalHeader()}
                {this.renderModalBody()}
                {!isCheckoutScreen ? this.renderModalFooter() : null}
            </div>
        )
    }
}

export default FreeProduct;

let styles = {
    headerStyle: {
        display: 'flex',
        padding: 20,
        justifyContent: 'center'
    },
    bodyContainer: {
        padding: 20
    },
    buttonsMainContainer: {
        width: '100%'
    },
    buttonsContainer: {
        display: 'flex',
        justifyContent: 'center',
        padding: 20,
        textAlign: 'center'
    },
    buttonsStyle: {
        borderRadius: 0,
        border: 'none',
        minWidth: 170,
        paddingTop: 10,
        paddingBottom: 10
    },
    editButton: {},
    mainContainer: {}
}